import { RegistrationSource } from 'domain/api/graphql/generated';

import { SignUpSourceValues } from './types';

export const YM_COUNTER_CLIENT_ID = 'YM_COUNTER_CLIENT_ID';
export const ROISTAT_VISIT_ID = 'ROISTAT_VISIT_ID';

export const PROD_COM_HOST_NAME = 'app.zvuk-b2b.com';
export const PROD_BY_HOST_NAME = 'app.zvuk-b2b.by';
export const DEV_HOST_NAME = 'smartlk-dev-1.zvuk-b2b.com';

export const YM_ID_TEST = 106500279;
export const YM_ID_COM = 89756199;
export const YM_ID_BY = 103837247;
export const YM_COUNTER_FALLBACK = 45300591;

export const SIGN_UP_SOURCE_MAP = {
  [RegistrationSource.Email]: SignUpSourceValues.EMAIL,
  [RegistrationSource.Phone]: SignUpSourceValues.PHONE,
  [RegistrationSource.SbOnline]: SignUpSourceValues.SBBOL,
  [RegistrationSource.SbBusinessId]: SignUpSourceValues.SBBID,
  [RegistrationSource.Admin]: SignUpSourceValues.ADMIN,
  [RegistrationSource.Yclients]: SignUpSourceValues.YCLIENTS,
} as const;
